<template>
	<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 18">
		<path
			stroke="currentColor"
			stroke-width="2"
			d="M5 1.8a3.6 3.6 0 0 0-3.6 3.6v7.2A3.6 3.6 0 0 0 5 16.2h12a3.6 3.6 0 0 0 3.6-3.6V5.4A3.6 3.6 0 0 0 17 1.8H5ZM3.8 12.6v-1.2h6v2.4H5a1.2 1.2 0 0 1-1.2-1.2Zm8.4 1.2H17a1.2 1.2 0 0 0 1.2-1.2v-1.2h-6v2.4Zm0-4.8h6V6.6h-6V9ZM9.8 6.6h-6V9h6V6.6Z"
			clip-rule="evenodd"
		/>
	</svg>
</template>
